var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4375 0.697754C10.7337 0.708701 10.0453 0.905162 9.4417 1.2673C8.83814 1.62943 8.34082 2.14442 7.99997 2.76025C7.65912 2.14442 7.16181 1.62943 6.55825 1.2673C5.95469 0.905162 5.26626 0.708701 4.56247 0.697754C3.44056 0.746498 2.38354 1.23729 1.62234 2.0629C0.861136 2.88851 0.45763 3.98183 0.499974 5.104C0.499974 7.94588 3.49122 11.0496 5.99997 13.154C6.56011 13.6247 7.26832 13.8828 7.99997 13.8828C8.73163 13.8828 9.43984 13.6247 9.99997 13.154C12.5087 11.0496 15.5 7.94588 15.5 5.104C15.5423 3.98183 15.1388 2.88851 14.3776 2.0629C13.6164 1.23729 12.5594 0.746498 11.4375 0.697754Z",
    fill: "#FF371D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartFilled);
export default __webpack_public_path__ + "static/media/HeartFilled.6ca40d1827a0c9e30ca05adf004a5675.svg";
export { ForwardRef as ReactComponent };